import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { RemoveLicenseSystemFromOrgPayload, RemoveLicenseSystemFromOrgInput } from './generated/types';
import { GqlError } from './GqlError';

const mutation = `mutation RemoveLicenseSystemFromOrg($input: RemoveLicenseSystemFromOrgInput!) {
    removeLicenseSystemFromOrg(input: $input) {
        licenseSystemId
        succeeded
    }
}`;

export const useRemoveLicenseSystemFromOrg = (licenseSystemId: string, orgId: string) => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {

            const input: RemoveLicenseSystemFromOrgInput = {
                licenseSystemId,
            };

            const { data } = await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<{
                data: {
                    removeLicenseSystemFromOrg: RemoveLicenseSystemFromOrgPayload;
                };
                errors?: Array<GqlError>;
            }>);

            const isSucceeded = !!data.removeLicenseSystemFromOrg.succeeded;

            return isSucceeded;
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['getOrganization', orgId] });
            // If we remove the license system and add it back again, the license system details must be fetched again.
            void queryClient.invalidateQueries({ queryKey: ['getLicenseSystemDetails', licenseSystemId] });
        },
    });
};